import React from 'react';
import { Card, CardContent, CardHeader } from '../../../components/ui/card';

import { AlertCircle } from 'lucide-react';
import SetupGuideSection from './SetupGuideSection';

const GettingStartedSection = () => {
  return (
    <div className="mb-12">
      <div className="mb-12" data-section="getting-started">
        <h2 className="text-2xl font-bold text-gray-900 mb-6">Getting Started</h2>
        <div className="grid md:grid-cols-2 gap-6">
          <ApiKeyCard />
          <AuthenticationCard />
        </div>
      </div>
      
      <div data-section="integration">
        <h2 className="text-2xl font-bold text-gray-900 mb-6">Integration Examples</h2>
        <SetupGuideSection />
      </div>
    </div>
  );
};

const ApiKeyCard = () => (
  <Card>
    <CardHeader>
      <h3 className="text-lg font-semibold">1. Get Your API Key</h3>
    </CardHeader>
    <CardContent>
      <ol className="space-y-4 text-gray-600">
        <li className="flex items-start">
          <span className="flex-shrink-0 w-6 h-6 rounded-full bg-blue-100 text-blue-600 flex items-center justify-center mr-3 mt-0.5">1</span>
          <span>Sign in to your <a href="https://console.deltaops.app" className="text-blue-600 hover:underline">DeltaOps Console</a></span>
        </li>
        <li className="flex items-start">
          <span className="flex-shrink-0 w-6 h-6 rounded-full bg-blue-100 text-blue-600 flex items-center justify-center mr-3 mt-0.5">2</span>
          <span>Navigate to Settings → API Keys</span>
        </li>
        <li className="flex items-start">
          <span className="flex-shrink-0 w-6 h-6 rounded-full bg-blue-100 text-blue-600 flex items-center justify-center mr-3 mt-0.5">3</span>
          <span>Click "Generate New Key" and save it securely</span>
        </li>
      </ol>
    </CardContent>
  </Card>
);

const AuthenticationCard = () => (
  <Card data-section="authentication">
    <CardHeader>
      <h3 className="text-lg font-semibold">2. Authenticate Your Requests</h3>
    </CardHeader>
    <CardContent>
      <p className="text-gray-600 mb-4">
        Include your API key in the Authorization header of all requests:
      </p>
      <div className="bg-gray-50 p-4 rounded-lg">
        <code className="text-sm text-gray-800">
          Authorization: Bearer YOUR_API_KEY
        </code>
      </div>
      <div className="mt-4 flex items-start space-x-2">
        <AlertCircle className="w-5 h-5 text-yellow-500 flex-shrink-0 mt-1" />
        <p className="text-sm text-gray-600">
          Keep your API key secure and never commit it to version control. Use environment variables or secrets management.
        </p>
      </div>
    </CardContent>
  </Card>
);

export default GettingStartedSection;